function firstFiniteNumber(text) {
  const match = String(text)
    .replace(/[`*[\]_]/g, "")
    .match(/\d+(?:\.\d+)?/);
  if (!match) return null;
  const value = Number(match[0]);
  return Number.isFinite(value) ? Math.round(value) : null;
}

/**
 * Read a labeled score from an analysis response.
 * Current model output puts the value on the next line (`65/100`).
 * Older output kept it on the label line (`Employability Score: 82`).
 */
export function extractScoreAfterLabel(lines, labelIndex) {
  if (!Array.isArray(lines) || labelIndex < 0 || labelIndex >= lines.length) {
    return null;
  }

  const labelLine = lines[labelIndex];
  const colonAt = labelLine.indexOf(":");
  const sameLine = colonAt >= 0 ? labelLine.slice(colonAt + 1) : "";
  const sameLineScore = firstFiniteNumber(sameLine);
  if (sameLineScore != null) return sameLineScore;

  for (let i = labelIndex + 1; i < lines.length; i += 1) {
    const line = lines[i].trim();
    if (!line) continue;
    return firstFiniteNumber(line);
  }
  return null;
}
